import { Arr } from '@deqo/foundation';
import { UniversalSurfaceRenderer } from '../../../../platform/UniversalSurfaceRenderer';
import { Matrix } from '../../../../platform/geom/Matrix';
import { Point } from '../../../../platform/geom/Point';
import { EmojiStore, emojiDraw } from '../../../../ui/emoji';
import { CoreAssets } from '../../../canvas/CoreAssets';
import { Particle } from './Particle';

export class EmojiParticle implements Particle {

    private lifetime = 5 * 3;
    private speed = 10;
    private age = 0;

    private position = null as Point;
    private emoji = Arr.random(EmojiStore.getEmoji()).id;

    constructor(
        public from: Point,
        public velocity: Point,
    ) {

    }

    public update(dt: number): boolean {
        this.age += dt;

        this.position = this.from.add(this.velocity.multiply(this.age * this.speed));

        return this.age < this.lifetime;
    }

    public paint(gfx: UniversalSurfaceRenderer, mvm: Matrix): void {
        gfx.setTransform(
            Matrix.identity
                .multiply(mvm)
                .translate(this.position)
                // .rotate(this.rot)
                .translate(-32, -32)
        );
        gfx.globalAlpha = 1 - this.age / this.lifetime;

        emojiDraw(CoreAssets.twemojiSprite, gfx as any, this.emoji, 0, 0, 64);
    }
}
